<template>
  <div class="flex flex-col">
    <label for="id" class="font-nutino font-bold text-[16px] text-[#535353] mb-2">{{ label }}</label>
    <input
      class="border border-[#5d5d5d] bg-[#fff] rounded-[20px]  focus:ring-[#FFC107] focus:border-[#FFC107] py-[18px] px-[24px]"
      :class="[
          errors && errors.length > 0 ? 'border-red-400 ring-red-400': '',
          variant === 'dark' ? 'bg-[#fff] bg-opacity-5 text-white' : 'bg-white bg-opacity-none text-black',
        ]"
      :id="id"
      type="text"
      v-model="model"
      :placeholder="placeholder"
    />
    <span class="text-red-400 text-xs" v-if="errors" v-for="error in errors" v-text="error"></span>
  </div>
</template>

<script setup lang="ts">

type TVariant = 'dark' | 'light';

interface Props {
  label: string
  placeholder?: string
  errors?: string[]
  variant?: TVariant
}

withDefaults(defineProps<Props>(), {
  variant: 'dark',
});

const id = useId();
const model = defineModel();



</script>
